import { Component, Input } from '@angular/core';
import { IListing } from '@curbnturf/entities';
import { ShareModule } from 'ngx-sharebuttons';

@Component({
  selector: 'curbnturf-share-listing',
  templateUrl: './share-listing.component.html',
  styleUrls: ['./share-listing.component.scss'],
  standalone: true,
  imports: [ShareModule],
})
export class ShareListingComponent {
  @Input() listing: IListing;
}
